import React from 'react';
import { Info, AlertTriangle, AlertCircle, type LucideIcon } from 'lucide-react';
import type { EventSeverity } from '../../types';
import './EventSeverityBadge.css';

export interface EventSeverityBadgeProps {
  /** Event severity level */
  severity: EventSeverity;
  /** Optional text to display next to icon */
  text?: string;
  /** Optional custom className */
  className?: string;
}

const SEVERITY_CONFIG: Record<
  EventSeverity,
  { label: string; modifier: string; Icon: LucideIcon }
> = {
  info: { label: 'Info', modifier: 'info', Icon: Info },
  warning: { label: 'Warnung', modifier: 'warning', Icon: AlertTriangle },
  action_required: {
    label: 'Handlungsbedarf',
    modifier: 'action',
    Icon: AlertCircle,
  },
};

export const EventSeverityBadge: React.FC<EventSeverityBadgeProps> = ({
  severity,
  text,
  className = '',
}) => {
  const config = SEVERITY_CONFIG[severity] ?? SEVERITY_CONFIG.info;
  const { Icon } = config;
  const displayText = text ?? config.label;

  return (
    <span
      className={`event-severity-badge event-severity-badge--${config.modifier} ${className}`.trim()}
    >
      <Icon size={14} />
      <span className="event-severity-badge__text">{displayText}</span>
    </span>
  );
};

export default EventSeverityBadge;
